<h1 [ngClass]="{'pl-3 pr-3 pt-1 pb-1 background-red':isError}" mat-dialog-title>
  {{title}}
</h1>

<h1 *ngIf="false" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <mat-icon>drag_handle</mat-icon>
  Draggable
  {{title}}
</h1>

<div [ngClass]="{'pl-3 pr-3 pt-1 pb-1':isError}" mat-dialog-content>
  <p>{{message}}</p>
</div>

<div [ngClass]="{'pl-3 pr-3 pt-1 pb-s':isError, 'pb-2':!isError }" mat-dialog-actions>
  <button *ngIf="!disableCancel" mat-button (click)="onDismiss()">No</button>


  <button [ngClass]="{'w-100':disableCancel, 'background-red': isError}" mat-raised-button [color]="'glb_greenbtn'" (click)="onConfirm()">
    <ng-container *ngIf="disableCancel">
      OK
    </ng-container>
    <ng-container *ngIf="!disableCancel">
      Yes
    </ng-container>

  </button>


</div>
